export enum ENTITY_ITEM_TYPE {
    SINGLE = 'SINGLE',
    GROUP = 'GROUP',
}
